import { get, post } from '../utils/request';

export interface WechatGroup {
  id: number;
  group_id: string;
  group_name: string;
  member_count?: number;
  status: string;
  owner_id?: number;
  created_at?: string;
}

export interface WechatGroupDetail extends WechatGroup {
  owner_userid?: string;
  create_time?: number;
  notice?: string;
  last_sync_at?: string;
  updated_at?: string;
}

export interface WechatGroupSyncResponse {
  success: boolean;
  synced_count: number;
  new_count: number;
  updated_count: number;
  message: string;
}

/**
 * Get WeChat groups list
 */
export const getWechatGroups = async (params?: {
  page?: number;
  page_size?: number;
  status?: string;
  keyword?: string;
  owner_id?: number;
}) => {
  const { page = 1, page_size = 20, ...rest } = params || {};
  return get('/wechat/groups/', {
    params: {
      skip: (page - 1) * page_size,
      limit: page_size,
      ...rest,
    },
  });
};

/**
 * Get WeChat group detail
 */
export const getWechatGroupDetail = async (groupId: number) => {
  return get(`/wechat/groups/${groupId}`);
};

/**
 * Sync WeChat groups from WeChat API
 */
export const syncWechatGroups = async (): Promise<WechatGroupSyncResponse> => {
  return post('/wechat/groups/sync', {});
};

/**
 * Get cases associated with a WeChat group
 */
export const getGroupCases = async (
  groupId: number,
  params?: {
    page?: number;
    page_size?: number;
  }
) => {
  const { page = 1, page_size = 20 } = params || {};
  return get(`/wechat/groups/${groupId}/cases`, {
    params: {
      skip: (page - 1) * page_size,
      limit: page_size,
    },
  });
};
